@if (data) {
  <div>
    <div class="spending-limit-row">
      <div>Daily limit</div>
      <div>
        <app-form-field-number
          [formGroup]="formGroup"
          [data]="data.dailyLimit.value"
          [fieldConfig]="fieldConfig"
          [editMode]="editMode"></app-form-field-number>
        <app-lookup-from-field
          [lookup]="'currency'"
          [formGroup]="formGroup"
          [data]="data.dailyLimit.currency"
          [fieldConfig]="fieldConfig"
          [editMode]="editMode"></app-lookup-from-field>
      </div>
    </div>
    <div class="spending-limit-row">
      <div>Weekly limit</div>
      <div>
        <app-form-field-number
          [formGroup]="formGroup"
          [data]="data.weeklyLimit.value"
          [fieldConfig]="fieldConfig"
          [editMode]="editMode"></app-form-field-number>
        <app-lookup-from-field
          [lookup]="'currency'"
          [formGroup]="formGroup"
          [data]="data.weeklyLimit.currency"
          [fieldConfig]="fieldConfig"
          [editMode]="editMode"></app-lookup-from-field>
      </div>
    </div>
    <div class="spending-limit-row">
      <div>Monthly limit</div>
      <div>
        <app-form-field-number
          [formGroup]="formGroup"
          [data]="data.monthlyLimit.value"
          [fieldConfig]="fieldConfig"
          [editMode]="editMode"></app-form-field-number>
        <app-lookup-from-field
          [lookup]="'currency'"
          [formGroup]="formGroup"
          [data]="data.monthlyLimit.currency"
          [fieldConfig]="fieldConfig"
          [editMode]="editMode"></app-lookup-from-field>
      </div>
    </div>
  </div>
}
